export const apiBaseUrl = 'https://www.sanlidaoutdoor.com/';
// export const apiBaseUrl = 'https://www.sanlidaoutdoor.com/';
//export const apiBaseUrl = 'https://test.sanlidaoutdoor.com/';

export const locationHost = process.env.NODE_ENV === 'production' ? apiBaseUrl : 'http://localhost:8080/';

